// Only declare the class if it doesn't exist
if (typeof FeaturedCardsSlider === 'undefined') {
  class FeaturedCardsSlider {
    constructor() {
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initSwiper());
      } else {
        this.initSwiper();
      }
    }

    initSwiper() {
      const swiperContainers = document.querySelectorAll('.featured-cards-swiper');

      swiperContainers.forEach(container => {
        // Skip if already initialized
        if (container.swiper) {
          return;
        }

        // Check if Swiper is available
        if (typeof Swiper === 'undefined') {
          console.warn('Swiper library not loaded');
          return;
        }

        // Find the navigation buttons in the parent container
        const parentContainer = container.closest('.featured-cards-slider');
        const nextButton = parentContainer ? parentContainer.querySelector('.swiper-button-next') : null;
        const prevButton = parentContainer ? parentContainer.querySelector('.swiper-button-prev') : null;

        new Swiper(container, {
          // Basic settings
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: false,
          loop: false,

          // Navigation
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },

          // Touch/Swipe support
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,

          // Responsive breakpoints
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },

          // Performance
          watchSlidesProgress: true,
          watchSlidesVisibility: true,

          // Accessibility
          a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
          },

          // Events
          on: {
            init: function() {
              // Add any initialization logic here
              console.log('Featured Cards Slider initialized');
            },
            slideChange: function() {
              // Handle slide change if needed
            }
          }
        });
      });
    }
  }

  // Initialize the slider
  window.FeaturedCardsSlider = FeaturedCardsSlider;
  new FeaturedCardsSlider();
}
